module.exports = __webpack_public_path__ + "img/i9.2602f5f3.jpg";